export default "__VITE_ASSET__5d7917a0__"